var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPasswordHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8567 17.4297L16.8318 16.2942C15.5571 17.0481 13.9583 17.5927 11.9995 17.5927C6.55675 17.5927 3.89397 13.3882 3.23898 12.1719C3.74582 11.2304 5.45505 8.49907 8.7245 7.31185L7.64887 6.12012C3.81981 7.7614 2.03535 11.2006 1.76139 11.7665C1.63682 12.0239 1.63682 12.32 1.76143 12.5774C2.12363 13.3254 5.12513 19.0927 11.9995 19.0927C14.4106 19.0927 16.3452 18.3832 17.8567 17.4297ZM9.86763 8.57836C8.64328 9.30699 7.82293 10.6436 7.82293 12.1718C7.82293 14.4795 9.69374 16.3503 12.0015 16.3503C13.3765 16.3503 14.5964 15.6862 15.3579 14.6612L14.321 13.5124C13.8576 14.3123 12.9924 14.8503 12.0015 14.8503C10.5222 14.8503 9.32293 13.6511 9.32293 12.1718C9.32293 11.0832 9.97224 10.1464 10.9047 9.72732L9.86763 8.57836Z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4983 15.3303C20.5567 14.2719 21.3817 12.6231 21.5617 12.2486C21.5856 12.1989 21.5869 12.1431 21.5645 12.0927C21.2143 11.3043 18.1152 4.87298 10.6499 5.99947M4.7998 3.59961L20.0898 20.3139",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0293 8.49316C13.7884 8.63893 14.4797 9.02688 14.9997 9.59882C15.5196 10.1708 15.8401 10.8959 15.913 11.6654",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPasswordHide);
export default __webpack_public_path__ + "static/media/ic_password_hide.26d65e7ed7c536abcb4a747ea8b24c48.svg";
export { ForwardRef as ReactComponent };